/* eslint-disable */
import React, { useContext, useMemo, useRef, useState } from "react";
import { Box } from "@mui/material";
import { StepProps } from "../../source-configurator.types";
import SourceFormBuilder from "../../source-form-builder";
import SidebarStepFooter from "../../sidebar-step-footer";
// @ts-ignore
import SourceInfoComponent from "src/modules/wizards/common/source-info-message-box/source-info-box.jsx";
import { WizardSourceFormComponent } from "app/components/common/editor/control/wizard-form-builder/wizard-form-builder";
import { wizardcontext } from "../../../source-configurator-tool";
import { sourceFormConfig } from "app/components/appwizard/component-wizards/wizards/source/database-reader/configs/source-form-info";
// @ts-ignore
import commonAdapterNameService from "core/services/componentService/common-adapter-name-service";
// @ts-ignore
import topologyInfoService from "core/services/componentService/topology-info-service";
import componentService from "core/services/componentService/component-service";
import { ConnectionParams } from "app/components/appwizard/component-wizards/wizards/source/database-reader/models";
const defaults = ConnectionParams.prototype.defaults;

const normalizeWithDefaultValue = (values: Record<string, unknown> | undefined) => {
    if (!values) return {};
    const withDefaultValues = { ...values };

    Object.entries(values).forEach(([key, value]) => {
        if (value === undefined || value === null) {
            if (defaults[key] !== undefined) {
                withDefaultValues[key] = defaults[key];
            }
        }
    });

    return withDefaultValues;
};
const SourceConfigForm = ({ onChange, onNext, onCancel }: StepProps) => {
    const formRef = useRef<any>(null);
    const [enableNext, setEnableNext] = useState(false);
    const { sourceType, setState, mode, connectionParams, targetComponentName } = useContext(wizardcontext);

    const handleFormChange = (value: Record<string, unknown>) => {
        setState((prev: Object) => ({
            ...prev,
            connectionParams: value
        }));
    };

    const handleNext = () => {
        const normalisedData = normalizeWithDefaultValue(connectionParams);
        setState((prev: Object) => ({
            ...prev,
            connectionParams: normalisedData
        }));
        onNext();
    };

    const isCDC = mode === "Change Data Capture";
    const isILCDC = mode === "Automated";

    const formFields = useMemo(() => {
        const fields = sourceFormConfig.getFormFields(sourceType, isCDC, isILCDC);
        return fields;
    }, []);

    const commonName = commonAdapterNameService
        .getCommonNames()
        .find((name: string) => name.toUpperCase() === sourceType);
    const ilComponent = commonName ? commonAdapterNameService.getILComponentName(commonName) : null;
    const targetName = componentService.getComponentIDFromAdapterName(targetComponentName) ?? targetComponentName;
    const hasAutoSchemaConversion =
        !isCDC &&
        !!ilComponent &&
        !!targetComponentName &&
        topologyInfoService.isSchemaSupportedTopology(ilComponent, targetName);

    return (
        <Box sx={{ width: "100%" }}>
            <SourceInfoComponent sourceID={sourceType?.toUpperCase()} />
            <Box mt={1}>
                <WizardSourceFormComponent
                    value={connectionParams}
                    formRef={formRef}
                    onChange={handleFormChange}
                    initialValues={connectionParams}
                    formFields={formFields}
                    setFormValid={setEnableNext}
                    hasAutoSchemaConversion={hasAutoSchemaConversion}
                    isAutomatedWizard={isILCDC}
                />
            </Box>
            <SidebarStepFooter showBack={false} onCancel={onCancel} onNext={handleNext} nextDisabled={!enableNext} />
        </Box>
    );
};

export default SourceConfigForm;
